const ANALYZE_URL = "https://qbfvrldtluwrqlmwwqvw.supabase.co/functions/v1/analyze"

export async function callAnalyzeAPI(
  type: "OBSTACLE" | "DECISION",
  content: string,
  language: "tr" | "en",
  context: any
) {
  const response = await fetch(ANALYZE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ type, content, language, context }),
  })

  if (!response.ok) {
    throw new Error("AI analysis failed")
  }

  const data = await response.json()
  return data.result
}

export async function checkSafety(
  text: string,
  language: "tr" | "en"
): Promise<{ safe: boolean; reason?: string }> {
  try {
    const response = await fetch(ANALYZE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: "SAFETY",
        content: text,
        language,
        context: {},
      }),
    })

    if (!response.ok) return { safe: false, reason: "safety_check_unavailable" }

    const data = await response.json()
    return {
      safe: data.safe !== false,
      reason: data.reason,
    }
  } catch {
    return { safe: false, reason: "safety_check_unavailable" }
  }
}